import { getLocalApiUrl } from '../config/api'

/** Blob ref from mobile_capture_json / incident attachments ({ url } or legacy base64). */
export function blobPreviewUrl(ref, mime = 'image/jpeg') {
  if (!ref) return null
  if (typeof ref === 'string' && ref.length > 0) {
    if (ref.startsWith('http') || ref.startsWith('data:')) return ref
    return getLocalApiUrl(ref)
  }
  if (typeof ref !== 'object') return null
  if (ref.retention_removed === true) return null
  if (typeof ref.url === 'string' && ref.url.length > 0) {
    const u = ref.url
    if (u.startsWith('http') || u.startsWith('data:')) return u
    return getLocalApiUrl(u)
  }
  const b64 = ref.image_base64 || ref.photo_jpeg_base64 || ref.data
  if (typeof b64 === 'string' && b64.length > 0) {
    return b64.startsWith('data:') ? b64 : `data:${mime};base64,${b64}`
  }
  return null
}
